import i18next from 'i18next';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { createBrowserHistory } from 'history';
import LanguageDetector from 'i18next-browser-languagedetector';

const history = createBrowserHistory();

// Detect language from URL path for consistent hydration
const getLanguageFromPath = (): string => {
  if (typeof window === 'undefined') return 'en';
  const match = window.location.pathname.match(/^\/(de|fr|es|pt)(\/|$)/);
  return match ? match[1] : 'en';
};

const initialLanguage = getLanguageFromPath();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage, // Force initial language from URL path
    fallbackLng: 'en',
    debug: false,
    supportedLngs: ['en', 'de', 'fr', 'es', 'pt'],
    resources: {
      en: {
        translation: require('./locales/en.json')
      },
      de: {
        translation: require('./locales/de.json')
      },
      fr: {
        translation: require('./locales/fr.json')
      },
      es: {
        translation: require('./locales/es.json')
      },
      pt: {
        translation: require('./locales/pt.json')
      }
    },
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    },
  });

document.documentElement.setAttribute("lang", i18n.language);

i18next.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  localStorage.setItem("i18nextLng", lng);
  if (lng === 'en') {
    history.push('/');
  } else {
    history.push(`/${lng}/`);
  }
});

export default i18n;
